import React  from 'react';
import StoryPointsComponentProto from './story-points-proto';

export default function renderListInIcon(props) {
    return <StoryPointsComponentProto renderMode="icon" {...props} />;
}